module.exports = "<span class=\"js-name member-text\">{{name}}</span>";